var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 13,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#BABDCC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.457 12.857c-.282-.196-.457-.565-.457-.965V1.108c0-.4.175-.769.456-.965a.752.752 0 0 1 .905.017l7.207 5.391c.268.201.432.561.432.949 0 .388-.164.748-.432.948L11.36 12.84a.752.752 0 0 1-.904.017zM.457 12.857C.175 12.661 0 12.292 0 11.892V1.108C0 .708.175.34.456.143a.752.752 0 0 1 .905.017L8.568 5.55c.268.201.432.561.432.949 0 .388-.164.748-.432.948L1.36 12.84a.752.752 0 0 1-.904.017z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double-arrow.bbd432dc71c54434ad5a85c1e29c79a8.svg";
export { ForwardRef as ReactComponent };